var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 117,
    viewBox: "0 0 117 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 117,
    height: 117,
    rx: 58.5,
    fill: "#99B1DB",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8125 85.5C28.4625 85.5 27.2813 84.9937 26.2688 83.9812C25.2563 82.9687 24.75 81.7875 24.75 80.4375V36.5625C24.75 35.2125 25.2563 34.0312 26.2688 33.0187C27.2813 32.0062 28.4625 31.5 29.8125 31.5H87.1875C88.5375 31.5 89.7188 32.0062 90.7312 33.0187C91.7437 34.0312 92.25 35.2125 92.25 36.5625V80.4375C92.25 81.7875 91.7437 82.9687 90.7312 83.9812C89.7188 84.9937 88.5375 85.5 87.1875 85.5H29.8125ZM87.1875 41.2031L59.85 59.0906C59.625 59.2031 59.4141 59.3016 59.2172 59.3859C59.0203 59.4703 58.7812 59.5125 58.5 59.5125C58.2188 59.5125 57.9797 59.4703 57.7828 59.3859C57.5859 59.3016 57.375 59.2031 57.15 59.0906L29.8125 41.2031V80.4375H87.1875V41.2031ZM58.5 54.9562L86.85 36.5625H30.2344L58.5 54.9562ZM29.8125 41.2031V41.7938V38.4609V38.5031V36.5625V38.5031V38.4188V41.7938V41.2031V80.4375V41.2031Z",
    fill: "#003CA4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.9f4f9f781daea2b65a421d37dab1dda0.svg";
export { ForwardRef as ReactComponent };